"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var utils_1 = require("../../../utils");
var Pill = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", alignItems: "center", borderRadius: 9999, paddingY: size === 'small' ? '0.4rem' : '0.8rem', paddingX: "1.2rem", fontSize: size === 'small' ? '1.2rem' : '1.4rem', whiteSpace: "nowrap", bgcolor: (0, utils_1.statusColors)(status), minWidth: "4.0rem", height: size === 'small' ? '2.6rem' : '3.0rem' }, { children: children })));
};
exports.default = Pill;
